export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/NI-45739c3ad26cb3ccec8ae9039eade43b.png";